/* istanbul ignore file */
import type { Route } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';
import { createPageRoute } from '@lumapps/router/utils';

/**
 * React admin page for a Content Type (CCT).
 * Slug follows the same convention as the sibling routes in packages/content/lists/routes.ts
 * (e.g. 'content-type/:uid/lists') — createPageRoute prepends '/admin/' automatically.
 */
export const contentTypeAdminContentRoute = createPageRoute({
    slug: 'content-type/:uid/content',
    appId: AppId.backOffice,
});

/** Navigate to the React CCT admin page. */
export const contentTypeAdminContent = (uid: string): Route => ({
    ...contentTypeAdminContentRoute,
    params: { uid },
});
